import {
  GetConfigPathsResponse,
  UpdatePathsConfigRequest,
  UpdatePathsConfigResponse,
} from "../../../types/api/configurations.type";
import httpClient from "../../client/HttpClient";

const ConfigurationsPathsService = {
  async list(): Promise<GetConfigPathsResponse> {
    const response = await httpClient.get<GetConfigPathsResponse>(
      "v1/config/internal-grade/paths",
    );
    return response;
  },
  async update(
    body: UpdatePathsConfigRequest,
  ): Promise<UpdatePathsConfigResponse> {
    const response = await httpClient.patch<
      UpdatePathsConfigRequest,
      UpdatePathsConfigResponse
    >("v1/config/internal-grade/paths", body);
    return response;
  },
};

export default ConfigurationsPathsService;
